"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _enum = require("@/utils/enum");
var _vuePropertyDecorator = require("vue-property-decorator");
var _CustomerTable = require("../customer/CustomerTable.vue");
var _FilterOrder = _interopRequireDefault(require("./components/FilterOrder.vue"));
var _OrderModal = _interopRequireDefault(require("./components/OrderModal.vue"));
var _initStore = require("@/store/initStore");
var _depositOrder = require("@/api/depositOrder.api");
var _SelectDateModal = _interopRequireDefault(require("@/components/Shared/SelectDateModal.vue"));
var _moment = _interopRequireDefault(require("moment"));
var _warehouse = require("@/api/warehouse");
var _reportConsignmentExcel = require("../warehouse/components/report-consignment-excel");
var ConsignmentTable = /*#__PURE__*/function (_Vue) {
  function ConsignmentTable() {
    var _this;
    (0, _classCallCheck2.default)(this, ConsignmentTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ConsignmentTable, [].concat(args));
    (0, _defineProperty2.default)(_this, "type", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "orders", []);
    (0, _defineProperty2.default)(_this, "ordersExport", []);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "query", {
      page: 1,
      limit: 10,
      type: ""
    });
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "filters", {});
    (0, _defineProperty2.default)(_this, "groupCustomerTrans", _CustomerTable.groupCustomerTrans);
    (0, _defineProperty2.default)(_this, "tagOptions", _enum.tagOptions);
    (0, _defineProperty2.default)(_this, "loadingExcel", false);
    (0, _defineProperty2.default)(_this, "row", void 0);
    return _this;
  }
  (0, _inherits2.default)(ConsignmentTable, _Vue);
  return (0, _createClass2.default)(ConsignmentTable, [{
    key: "mounted",
    value: function mounted() {
      this.query.type = this.type;
      this.fetchOrders();
    }
  }, {
    key: "created",
    value: function created() {
      _initStore.configurationStore.fetchData();
    }
  }, {
    key: "fetchExportReportByCustomer",
    value: function () {
      var _fetchExportReportByCustomer = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var extendQuery,
          query,
          res,
          _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              extendQuery = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              query = (0, _objectSpread2.default)({}, extendQuery);
              _context.next = 4;
              return _warehouse.warehouseApi.findReportConsignByCustomer(query);
            case 4:
              res = _context.sent;
              return _context.abrupt("return", res.data);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function fetchExportReportByCustomer() {
        return _fetchExportReportByCustomer.apply(this, arguments);
      }
      return fetchExportReportByCustomer;
    }()
  }, {
    key: "handleExportExcel",
    value: function handleExportExcel() {
      this.$refs.SelectDateModal.handleCreate();
    }
  }, {
    key: "handleSelectDateOk",
    value: function () {
      var _handleSelectDateOk = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(_ref) {
        var startDate, endDate, fromMonth, toMonth, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              startDate = _ref.startDate, endDate = _ref.endDate;
              fromMonth = startDate, toMonth = endDate;
              this.loadingExcel = true;
              _context2.next = 5;
              return this.fetchExportReportByCustomer({
                fromMonth: fromMonth,
                toMonth: toMonth
              });
            case 5:
              data = _context2.sent;
              this.loadingExcel = false;
              (0, _reportConsignmentExcel.exportReportByCustomerExcel)({
                data: data,
                fromDate: (0, _moment.default)(fromMonth).format("DD.MM.YYYY"),
                toDate: (0, _moment.default)(toMonth).format("DD.MM.YYYY")
              });
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleSelectDateOk(_x) {
        return _handleSelectDateOk.apply(this, arguments);
      }
      return handleSelectDateOk;
    }()
  }, {
    key: "handleFilter",
    value: function handleFilter(filters) {
      this.query.page = 1;
      this.filters = filters;
      this.fetchOrders();
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(row) {
      this.$refs.modal.handleUpdate(row);
    }
  }, {
    key: "fetchOrders",
    value: function () {
      var _fetchOrders = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              this.loading = true;
              _context3.next = 4;
              return _depositOrder.depositOrderApi.findAll((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), this.filters));
            case 4:
              res = _context3.sent;
              this.orders = res.data.depositOrders;
              this.total = res.data.total;
            case 7:
              _context3.prev = 7;
              this.loading = false;
              return _context3.finish(7);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0,, 7, 10]]);
      }));
      function fetchOrders() {
        return _fetchOrders.apply(this, arguments);
      }
      return fetchOrders;
    }()
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.$refs.modal.handleCreate();
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ConsignmentTable.prototype, "type", void 0);
ConsignmentTable = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    OrderModal: _OrderModal.default,
    FilterOrder: _FilterOrder.default,
    SelectDateModal: _SelectDateModal.default
  }
})], ConsignmentTable);
var _default = exports.default = ConsignmentTable;